export default [
  {
    path: '/admin/apply/plugin/list',
    name: 'pluginList',
    component: () => import('@/views/apply/plugin/plugin_list'),
    meta: {
      title: '插件列表',
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/plugin.js